import { render } from "./SecondNavbar.vue?vue&type=template&id=8b49ca30&scoped=true"
const script = {}

import "./SecondNavbar.vue?vue&type=style&index=0&id=8b49ca30&scoped=true&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b49ca30"]])

export default __exports__